// import { useState, useEffect } from 'react';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import './App.css';
// import ErrorBoundary from './components/common/ErrorBoundary';
// import userContext from './configs/context/context';
// import { AuthProvider } from './hooks/AuthProvider';
// import Layout from './components/common/Layout';
// import HomePage from './components/common/HomePage';
// import Orders from './components/page/airtel/Airtel';
// import Product from './components/page/products/Product';
// // import Enquiry from './components/page/enquiry/Enquiry';
// // import Wholesale from './components/page/jio/Jio';
// // import CustomerPage from './components/page/customers/CustomerPage';
// // import Page from './components/forms/Login';
// // import CreateProducts from './components/forms/CreateProducts';
// import LoginPage from './components/forms/Login';
// import ProtectedRoute from './components/common/ProtectedRoute'; // Adjust the import according to your file structure
// import ProductEnquiry from './components/page/ProductEnquiry/ProductEnquiry';
// import 'react-toastify/dist/ReactToastify.css';
// import IconComponent from './components/page/icons/IconComponent';
// import Jio from './components/page/jio/Jio';
// import Vi from './components/page/vi/Vi';
// import Tata from './components/page/tata/Tata';
// import PlansPage from './components/page/plansPage/PlanSPage';
// // import CurrencyConvert from './components/page/currencyConvert/CurrencyConvert';
// // import Users from './components/page/users/Users';
// // import ForgotPassowrdComponent from './components/page/ForgotPassowrd/ForgotPassowrdComponent';
// // import ResetPasswordComponent from './components/page/ResetPassword/ResetPasswordComponent';

// function App() {
// 	const [cart, setCart] = useState([]);
// 	const [isAuthenticated, setIsAuthenticated] = useState(false);
// 	const defaultValue = {
// 		cart,
// 		setCart,
// 		isAuthenticated,
// 		setIsAuthenticated,
// 	};

// 	useEffect(() => {
// 		const accessToken = localStorage.getItem('token');
// 		if (accessToken) {
// 			setIsAuthenticated(true);
// 		} else {
// 			setIsAuthenticated(false);
// 		}
// 	}, []);

// 	return (
// 		<ErrorBoundary>
// 			<userContext.Provider value={defaultValue}>
// 				<AuthProvider>
// 					<BrowserRouter>
// 						<Routes>
// 							<Route path="/login" element={<LoginPage />} />
// 							{/* <Route path="/forgot-password" element={<ForgotPassowrdComponent />} /> */}
// 							{/* <Route path="/reset-password/:param" element={<ResetPasswordComponent />} /> */}
// 							<Route element={<ProtectedRoute />}>
// 								<Route path="/" element={<Layout />}>
// 									<Route path="/" element={<HomePage />} />
// 									<Route path="/icon" element={<IconComponent />} />
// 									<Route path="/product" element={<Product />} />
// 									{/* <Route path="/product/create" element={<CreateProducts />} /> */}
// 									<Route path="/airtel" element={<Orders />} />
// 									<Route path="/jio" element={<Jio />} />
// 									<Route path="/vi" element={<Vi />} />
// 									<Route path="/tata" element={<Tata />} />

// 									<Route path="/airtel/:slug" element={<PlansPage />} />
// 									<Route path="/jio/:slug" element={<PlansPage />} />
// 									<Route path="/vi/:slug" element={<PlansPage />} />
// 									<Route path="/tata/:slug" element={<PlansPage />} />

// 									<Route path="/product-enquiry" element={<ProductEnquiry />} />
// 								</Route>
// 							</Route>
// 						</Routes>
// 					</BrowserRouter>
// 				</AuthProvider>
// 			</userContext.Provider>
// 		</ErrorBoundary>
// 	);
// }

// export default App;
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
// ==============================================================================
import { useState, useEffect, useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
// Context & Providers
import userContext from './configs/context/context';
import { AuthProvider } from './hooks/AuthProvider';
// Error Handling
import ErrorBoundary from './components/common/ErrorBoundary';
import ProtectedRoute from './components/common/ProtectedRoute';
// Layout & Pages
import Layout from './components/common/Layout';
import HomePage from './components/common/HomePage';
import LoginPage from './components/forms/Login';
// Feature Pages
// import Product from './components/page/products/Product';
import Orders from './components/page/airtel/Airtel';
import Jio from './components/page/jio/Jio';
import Vi from './components/page/vi/Vi';
import Tata from './components/page/tata/Tata';
import PlansPage from './components/page/plansPage/PlanSPage';
// import ProductEnquiry from './components/page/ProductEnquiry/ProductEnquiry';
import IconComponent from './components/page/icons/IconComponent';

import 'react-toastify/dist/ReactToastify.css';

function App() {
	const [cart, setCart] = useState([]);
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	// Memoize context value to avoid unnecessary re-renders
	const contextValue = useMemo(
		() => ({
			cart,
			setCart,
			isAuthenticated,
			setIsAuthenticated,
		}),
		[cart, isAuthenticated]
	);

	// Set auth status on app load
	useEffect(() => {
		const accessToken = localStorage.getItem('token');
		setIsAuthenticated(!!accessToken);
	}, []);

	return (
		<ErrorBoundary>
			<userContext.Provider value={contextValue}>
				<AuthProvider>
					<BrowserRouter>
						<Routes>
							Public Route
							<Route path="/login" element={<LoginPage />} />
							{/* Protected Routes */}
							<Route element={<ProtectedRoute />}>
								<Route path="/" element={<Layout />}>
									<Route index element={<HomePage />} />
									<Route path="icon" element={<IconComponent />} />
									{/* <Route path="product" element={<Product />} /> */}
									<Route path="airtel" element={<Orders />} />
									<Route path="jio" element={<Jio />} />
									<Route path="vi" element={<Vi />} />
									<Route path="tata" element={<Tata />} />

									{/* Dynamic Plan Pages */}
									<Route path="airtel/:slug" element={<PlansPage />} />
									<Route path="jio/:slug" element={<PlansPage />} />
									<Route path="vi/:slug" element={<PlansPage />} />
									<Route path="tata/:slug" element={<PlansPage />} />

									{/* <Route path="product-enquiry" element={<ProductEnquiry />} /> */}
								</Route>
							</Route>
						</Routes>
					</BrowserRouter>
				</AuthProvider>
			</userContext.Provider>
		</ErrorBoundary>
	);
}

export default App;
